import type React from "react";
import { Loader2 } from "lucide-react";
import { i18n } from "@frontend/i18n";

interface GenerateMoreButtonProps {
  readonly onClick: () => void;
  readonly isLoading: boolean;
}

export function GenerateMoreButton({
  onClick,
  isLoading,
}: GenerateMoreButtonProps): React.JSX.Element {
  return (
    <div className="py-4">
      <button
        type="button"
        onClick={onClick}
        disabled={isLoading}
        className="h-10 px-3 rounded-lg text-sm font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center bg-muted border border-border text-foreground hover:bg-accent"
        data-testid="directory-generate-more-button"
      >
        {isLoading && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
        {isLoading
          ? i18n.t("user.directory.topPicks.generating")
          : i18n.t("user.directory.topPicks.generateMore")}
      </button>
    </div>
  );
}
